import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet }      from '@angular/router';
import { NewHeaderComponent }        from '../../../shared/components/new-header/new-header.component';
import { FooterComponent }           from '../../../shared/components/footer/footer.component';

@Component({
  selector: 'pin-new-public-shell',
  templateUrl: './new-public-shell.component.html',
  imports: [NewHeaderComponent, RouterOutlet, FooterComponent]
})
export class NewPublicShellComponent implements OnInit {
  isRegistrationPage = false;
  private router = inject(Router);

  ngOnInit() {
    this.isRegistrationPage = this.router.url === '/register';
  }

}
